import { RentalscapeConfig } from '^/api/ariadne/__generated_types__/graphql';
import { useSelector } from 'react-redux';

export default function useRentalscapeConfig() {
  // TODO: FIXME: TECHDEBT-334: Fix with the correct type when the types are available for redux state
  const rentalscapeConfig = useSelector(
    (state) => (state as any)?.data?.rentalscapeConfig
  );
  return rentalscapeConfig as RentalscapeConfig | undefined;
}
